import Swiper, { Autoplay } from 'swiper'
import 'swiper/css'
import 'swiper/css/autoplay'

export class IndexGallerySlider {
  constructor() {
    if (document.getElementById('js-gallery_top') === null) return
    const galleryTopSlider = new Swiper('#js-gallery_top', {
      modules: [Autoplay],
      slidesPerView: 1.36,
      spaceBetween: 3,
      loop: true,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        767: {
          slidesPerView: 2.9,
        },
      },
    })
    const galleryBottomSlider = new Swiper('#js-gallery_bottom', {
      modules: [Autoplay],
      slidesPerView: 1.36,
      spaceBetween: 3,
      loop: true,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        reverseDirection: true,
      },
      breakpoints: {
        767: {
          slidesPerView: 2.9,
        },
      },
    })
  }
}
